import * as React from 'react';

import {
  Create,
  NumberInput,
  SimpleForm,
  TextInput,
  required,
  useTranslate,
} from 'react-admin';

import { MyTranslatableInputs } from '../../../components/MyTranslatableInputs';

const CategoriesCreate = () => {
  const translate = useTranslate();

  return (
    <Create>
      <SimpleForm>
        {/* <TextInput
          source="name"
          label={translate('resources.marketing_materials.fields.name')}
          validate={[required()]}
        /> */}
        <MyTranslatableInputs groupKey="name">
          <TextInput
            source="nameTranslated"
            label={translate(
              'resources.marketing_materials.categories.fields.name'
            )}
            // validate={[required()]}
          />
        </MyTranslatableInputs>
        <NumberInput
          source="order"
          label={translate(
            'resources.marketing_materials.categories.fields.order'
          )}
          min={1}
          max={99}
          step={1}
          validate={[required()]}
          style={{ width: 160 }}
        />
      </SimpleForm>
    </Create>
  );
};

export default CategoriesCreate;
